module.exports = __webpack_public_path__ + "static/media/office02.96d3398f.jpg";